export const environment = {
  PROD: true,
  SENTRY_ENV: "production",
  SSO_URL: "https://sso.rioingenieria.cl",
  API_URL: "https://iot.rioingenieria.cl",
  BO_URL: "https://bo.rioingenieria.cl",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyDZgmx4rM7Ujf2nZfPpKm7WyJlqULkSC8A",
    authDomain: "octocelio-ce395.firebaseapp.com",
    projectId: "octocelio-ce395",
    messagingSenderId: "841711062544",
    appId: "1:841711062544:web:c0138308708c2f368fc495",
  },
  FIREBASE_VAPID_KEY:
    "BPn-UdzBtS9W3SYhGzMwgiz1XK59FWwnbs6nhSOSv5z5VEhqJmHpRPpehxMbThwjS8yr4xzrxz9i605h2gIyv58",
};
